import { render } from "./MenuListing.vue?vue&type=template&id=69946c49"
import script from "./MenuListing.vue?vue&type=script&lang=js"
export * from "./MenuListing.vue?vue&type=script&lang=js"
script.render = render

export default script